export default __webpack_public_path__ + "static/media/Suparco.e120bc1c.png";